"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  contract: {
    successMessage: '航次任务布置成功',
    messageTwo: '只能选择一条',
    messageThree: '请选择要布置的航次',
    contractNoone: '所挂合同',
    movement: '船舶动态',
    //shipName:'船舶名称',
    voyageTypeOne: '航次状态',
    btnVoyageOne: '布置航次任务',
    refresh: '刷新',
    btnVoyage: '布置航次',
    registrationWithSeal: '用印登记',
    numberOfSealsUsed: '用印数量',
    printingTime: '用印时间',
    arrangement: '布置',
    cargoLoad: '未维护航次货载',
    noDeliveryInfo: '未锁定交船信息',
    importData: '导入数据',
    look: '查看',
    addVessage: '添加船舶及航次',
    searchFilterOne: '可查询船东、经纪人',
    searchFilterTwo: '可查询租家、经纪人',
    searchFilterThree: '可查询船东、管理公司',
    contractStatus_one: '合同状态必须为拟稿',
    contractStatus_two: '合同状态必须为生效',
    contractStatus_three: '合同状态必须为终止',
    contractStatus_one_or_three: '合同状态必须为拟稿或者终止',
    contractStatus_four: '合同状态必须为废弃',
    contractStatus_five: '合同状态必须为完成',
    contract: '合同',
    contractStopSuccess: '合同终止成功',
    contractStopFail: '合同终止失败',
    contractStop: '合同终止',
    approveType: '审批类型',
    approveStatus: '审批状态',
    approveTime: '提交时间',
    handler: '当前处理人',
    handleTaskNode: '当前处理环节',
    // taxFlag: '合同是否含税',
    contractRoute: '合同航线',
    // cargoGroup: '',
    demuClaimLimitFlag: '滞期费索赔时效标识',
    limitTermsFlag: '合同时效条款标识',
    pleaseEnterBatchAndQuantity: '请输入批次以及单批次',
    contractVersion: '合同版本',
    lastModifyByName: '更新人',
    lastModifyTime: '更新时间',
    demurrageCarges: '滞期费',
    createTime: '经办时间',
    jurisdiction: '管辖地',
    applicableLaw: '适用法律',
    contractTemplateCode: '合同范本编号',
    contractTemplate: '合同范本',
    effectiveDesc: '生效说明',
    contractSignApproval: '合同签订审批',
    contractChangeApproval: '合同变更审批',
    contractStopApproval: '合同终止审批',
    editHistoryContract: '合同变更',
    cargoLoadStartTime: '起装时间',
    cargoLoadEndTime: '结束时间',
    cargoName: '货品',
    cargoPlan: '货量计划',
    unitBatchQuantity: '单批次',
    makeInfo: '生成信息',
    totalLoadMin: '总载数Min',
    totalLoadMax: '总载数Max',
    loadAppointor: '指定方',
    loadAppointor2: '总载数指定方',
    layDesc: '受载期描述',
    periodDesc: '期租描述',
    lockBeginDate: '锁定开始时间',
    lockEndDate: '锁定结束时间',
    lockDay: '合计',
    inShipContract: '租入船合同',
    outShipContract: '租出船合同',
    coaAndVcvContract: 'COA/CVC合同',
    viewVideoFiles: '查看合同附件',
    deleteSuccess: '删除成功',
    deleteFail: '删除失败',
    contractNo: '合同号',
    contractDate: '合同日期',
    vesselName: '船舶',
    companyNameEn: '管理公司',
    contractType: '合同类型',
    coaContractNo: '所属COA合同',
    voyageNo: '航次号',
    chartererName: '租家',
    contractStatus: '合同状态',
    fileName: '文件名',
    createName: '经办人',
    majorFlag: '重大合同标记',
    approvalStatus: '审批状态',
    vesselType: '船型部',
    title: 'TC-IN/OUT合同编辑',
    escrowTitle: '商务代管合同编辑',
    oneTitle: '经营管理',
    twoTitle: '租船合同管理',
    information: '租船信息查询',
    latestChtrsoutInfo: '租出船当前信息查询',
    allChtrsOutiInfo: '租出船组合查询',
    twoEscrowTitle: '商务代管合同管理',
    threeTitle: 'VC-IN/OUT合同编辑',
    vcInTitle: 'VC-IN合同编辑',
    vcOutTitle: 'VC-OUT合同编辑',
    fourTitle: '租入船合同审批单',
    fiveTitle: '租出船合同审批单',
    print: '打印',
    contractCopy: '复制新增合同',
    contractInvalid: '合同签订生效',
    contractInvalid2: '合同变更生效',
    contractInvalid3: '合同终止生效',
    task: '布置航次任务',
    contractSuccess: '合同完成',
    editOBO: 'OBO合同编辑',
    copyOBO: '复制OBO合同',
    copyVc: '复制VC-IN合同',
    copyVcOut: '复制VC-OUT合同',
    void: '合同作废',
    splittingContracts: '拆分子合同',
    edit: '修改经纪人',
    contractName: '合同名称',
    placeholder: '请输入内容',
    placeholder3: '请输入交船期信息',
    placeholder4: '请输入租期性质信息',
    placeholder5: '请输入租期长度信息',
    placeholder6: '请输入碳税信息',
    placeholder7: '请点击选择航线',
    placeholder8: '点击使用公式计算器',
    placeholder9: '请输入代管期限信息',
    formulaCalculator: '公式计算器',
    placeholderSelect: '请选择',
    fleetName: '船队',
    voyageType: '船型团队',
    summaryCommRate: '汇总佣金率',
    contractCurrency: '合同币种',
    tradeFlag: '内外贸标志',
    titleTwo: '船舶信息',
    vesselSummerWeight: '夏季货载重吨',
    vesselFullLoaddraft: '满载吃水',
    vesselDesc: '船舶描述',
    titieThree: '签约信息',
    signSubjectName: '签约主体',
    signNetwork: '签约网点',
    signatory: '签署人',
    ourSignatory: '我方签署人',
    counterpartySignatory: '相对方签署人',
    isProvideSecurity: '提供合同担保',
    isSublet: '转租合同',
    agentName: '经纪人',
    beginDate: '起始时间从',
    endDate: '起始时间到',
    pleaseEnterBeginDate: '请选择开始时间',
    pleaseEnterEndDate: '请选择结束时间',
    tenancyDate: '租期',
    // isSublet: '是否转租合同',
    chartererComm: '佣金',
    signArea: '地区',
    // brokerName: '经纪人',
    brokerBillStandards: '计费标准',
    commPayer: '支付方',
    brokerCommDesc: '佣金描述',
    brokerName: '经纪人',
    shipmentAndCargoInfo: '运价&货物信息',
    attInformation: '附件信息',
    otherTerms: '其他条款',
    norTerms: 'NOR条款',
    oneTable: '租期/租金',
    twoTab: '货量信息',
    threeTab: '交还船信息',
    fourTab: '其他条款',
    fiveTab: '租约及附件信息',
    sixTab: '合同归档及法务信息',
    sevenTab: '其他条款及时效条款',
    standard: '标准',
    index: '指数',
    mix: '混合',
    rentType: '租金类型',
    feeType: '费用类型',
    feeNum: '费用',
    dateTime: '交船期',
    rentLength: '租期长度',
    custodyPeriod: '代管期限',
    ctaxStandard: '碳税标准',
    unit: '(元/吨)',
    chartererBear: '租家承担(%)',
    ctaxStandardRemark: '碳税备注',
    LeaseInformation: '租期信息',
    LeaseInformationone: '租金/航次信息',
    periodStartTime: '开始时间',
    periodEndTime: '结束时间',
    periodDay: '天数',
    periodRentDay: '日租金(元/天)',
    layBeginDate: '受载期开始',
    layEndDate: '受载期结束',
    cTaxStandard: '碳税标准(元/吨)',
    cTaxStandardUnit: '碳税标准单位',
    // chartererBear: '租家承担',
    pleaseChooseTime: '请选择时间',
    rateInformation: '运价信息',
    freightType: '运价类型',
    freightFee: '运价',
    freightFeeType: '运价类型',
    freightRate: '运价费率',
    freightTax: '运价含税',
    cargoInformation: '货物信息',
    excess: '超出货量',
    dockInformation: '装卸信息',
    delayFeeAndOtherExpenses: '滞速费&其他费用',
    delayFee: '滞速费',
    cargoOqMin: '货物超出Min',
    cargoOqMax: '货物超出Max',
    cargoOqStandards: '货物超出标准',
    cargoOqMode: '货物超出方式',
    invoiceType: '发票及税率',
    freightDesc: '运费条款',
    attaFeeTerms: '附加运费条款',
    attaFeeTerms2: '附加费条款',
    cargoType: '货物种类',
    cargoCode: '货物编码',
    cargoUnit: '货物单位',
    cargoQuantity: '货物数量',
    cargoVolumeMax: '货量max',
    weight: '重量',
    volumeNumber: '体积/件数',
    cargoDesc: '货物描述',
    polOrArea: '装货港/地区',
    podOrArea: '卸货港/地区',
    loadEfficiency: '装货效率/时间',
    loadEfficiencyUint: '装货效率/时间单位',
    dischargeEfficiency: '卸货效率/时间',
    dischargeEfficiencyUnit: '卸货效率/时间单位',
    totalHandling: '装卸时间合计',
    layTerm: '装货条款',
    demurrageRate: '滞期费率',
    delayRate: '延滞费率',
    dispatchRate: '速遣费率',
    demurrageDispatchTerms: '速遣条款',
    demuDispTermDesc: '滞速费描述',
    otherFeeDesc: '其他费用描述',
    open: '展开',
    close: '折叠',
    limitTerms: '合同时效条款',
    demuClaimLimit: '滞期费索赔时效',
    otherClaimLimit: '其他索赔时效',
    // cargoOqMode: '货物超出方式',
    messageTime: '请填写开始时间或结束时间',
    indexCalcMode: '指数假期计算方式',
    indexCompMode: '指数补差方式',
    isIndexRange: '设置指数范围',
    isDispute: '是否发生纠纷',
    isInsurance: '是否有保险',
    disputeAmount: '纠纷金额(原币)',
    compareMode: '比较模式',
    isOriginalContract: '是否正本合同',
    isBreakingIwl: 'BREAKING IWL',
    isCargoArea: '进入货损货差区域',
    escrowContractNo: '所属代管船合同',
    vesselEstStartTime: '预计开始时间',
    vesselEstDay: '预计航次天数',
    commModel: '佣金模式',
    isDeducted: '是否抵扣运费',
    actualCharterer: '实际租家',
    isChartererEnable: '启用',
    tipOne: '有实际租家并与承租人不一致时，需要录入实际租家并提交审批启用',
    owner: '船东',
    ownerComm: '佣金',
    ownerCommUnit: '佣金单位',
    ownerSignatory: '签署人',
    otherInformation: '其他信息',
    pdpr: ' PDPR',
    contractSummary: '合同摘要',
    contractEvaluation: '合同评价',
    palletNo: '货盘编号',
    batchNo: '批次号',
    isForwardPallet: '是否为远期货盘',
    route: '航线权重',
    rounte: '航线',
    indexWeight: '权重(%)',
    indexFloor: '指数范围',
    indexCeiling: '指数上线',
    indexFormula: '公式',
    paymentFrequency: '支付频率',
    ballastComp: '空放补偿(元)',
    loadPortName: '装港/地区',
    dischargePortName: '卸港/地区',
    // cargoType: '货物种类',
    cargoQuantityMin: '装货量(min)',
    cargoQuantityMax: '装货量(max)',
    // cargoUnit: '货种单位',
    cargoQuantityFloat: '货量浮动(%)',
    // cargoDesc: '货物描述'
    ship: '预计交船',
    shipone: '预计还船',
    eDelHfoPrice: '高硫重油价格',
    eDelIfoPrice: '低硫重油价格',
    price: '价格',
    yuan: '元',
    eDelHdoPrice: '高硫轻油价格',
    eDelIdoPrice: '低硫轻油价格',
    eDelType: '交船条款',
    eDelPaymode: '交船方式',
    eEPrice: '交还船油价是否相同',
    eDelPorts: '交船时间/地点',
    eDelRemark: '交船备注',
    eRedType: '还船条款',
    eRedPaymode: '还船方式',
    eREPrice: '还船油价相同',
    eRedPorts: '还船时间/地点',
    eRedRemark: '还船备注',
    depositeMode: '首付款模式',
    depositeRentDays: '首付租金天',
    cve: 'C/V/E(元)',
    ILOHC: 'ILOHC',
    rentDesc: '租金描述',
    escrowDescription: '代管描述',
    ownerName: '船东',
    mgCompanyName: '控股公司',
    ownerName02: '实际收款人',
    importantFlag: '是否重大合同',
    cargoGroup: '货种分组',
    submit: '提交',
    contractInvalidSuccess: '合同生效成功',
    contractInvalidFail: '合同生效失败',
    contractFinishSuccess: '合同完成成功',
    contractFinishFail: '合同完成失败',
    contractVoidSuccess: '合同作废成功',
    contractVoidFail: '合同作废失败',
    failMessage: '保存失败,请重试',
    cuplicateContractNumber: '合同号重复,请确认合同日期及船舶',
    handlingFee: 'Handling Fee',
    returnedDrafter: '返起草人',
    makeCopyFor: '抄送',
    viewContractSummary: '查看合同摘要',
    viewRECAP: '查看RECAP',
    viewVoyageCalculation: '查看航次测算',
    approval: '审批',
    withdraw: '撤回',
    approvalType: '审批类型',
    shipName: '船名',
    riskControlScreening: '风控筛查',
    screeningType: '筛查类型',
    report: '报告',
    reportingTime: '报告时间',
    operation: '操作',
    shipCode: '船舶规范',
    deadweightTon: '载重吨',
    builtinfo: '建造年份、地点',
    totalLength: '总长',
    wide: '宽',
    grossTon: '总吨',
    speed: '航速L/B',
    fuelConsumption: '耗油',
    other: '其他',
    mainIdeaOfTheLease: '租约大意',
    loadingPeriod: '受载期',
    delivery: '交船（装港）',
    redelivery: '还船（卸港）',
    loadPort: '装港',
    DischargePort: '卸港',
    timeLease: '期租（货物）',
    rent: '租金（运费）',
    brokerageCommission: '经纪/佣金',
    approvalComments: '审批意见',
    serialNumber: '序号',
    approvalProcess: '审批环节',
    approvalTime: '审批时间',
    approver: '审批人',
    corporateName: '公司名称',
    approvalDepartment: '审批部门',
    approvalOperation: '审批操作',
    approvalFormForCharteredShips: '海宏轮船（香港）有限公司 租入船舶审批表',
    internalApprovalFormOfShipLeaseContract: '海宏轮船（香港）有限公司 船舶租赁合同内部审批表',
    laycan: 'Laycan',
    contractApprovalTitle: '合同审批单',
    internalApprovalForm1: '船舶租赁合同内部审批表（非重大）',
    internalApprovalForm2: '船舶租赁合同内部审批表（重大）',
    loadingUnloadingInformation: '装卸信息',
    leaseCommission: '租期佣金',
    listOfAttachments: '附件清单',
    relevantProvisions: '相关条款',
    specialprescription: '特殊时效',
    effectedDate: '生效日期',
    endDatePool: '终止日期',
    signRemark: '签约备注',
    companyName: 'POOL公司',
    poolOneTable: '管理费/租期租金',
    poolManage: 'POOL管理费',
    deposit: '押金',
    deposit2: '押金Deposit',
    managementFee: '管理费',
    managementComm: '商务管理费佣金',
    managementTime: '管理费/时间',
    managementFeeRemark: '备注',
    rentpayTerm: '租金支付条款',
    exitPoolTerm: '退出POOL条款',
    messageInfo: '合同号重复，请重新选择',
    editContractVersion: '编辑历史合同',
    preservation: '保存',
    abstractContract: '合同摘要',
    seventTab: '航次测算',
    eightTab: '执行航次',
    nightTab: '租家历史合同',
    tenTab: '租家历史航次',
    nineTen: '合同审批单',
    twfTab: '合同归档',
    contractSign: '合同签订审批',
    contractChange: '合同变更审批',
    contractterminna: '合同终止审批',
    companyNameOne: '管理公司',
    titlePool: 'POOL合同编辑',
    taxFlag: '是否含税',
    errorWaring: '请填写交船方式',
    validateMessage: '请正确填写必填项',
    oneMessage: '必须存在一条数据',
    nonchartering: '非租船管理合同',
    year: '年份',
    contractIsFile: '是否归档',
    contractNo2: '合同编号',
    handlingDepartment: '经办部门',
    Amount: '原币金额',
    Equivalent: '纠纷金额(本位币)',
    DisputeDesc: '纠纷描述',
    DealMode: '处理方式',
    ExternalLawyerFlag: '是否外部律师',
    LawFirmName: '律师事务所名称',
    DealDesc: '处理描述',
    Desc: '其他备注',
    placeholder2: '请输入',
    ourTheme: '我方主题',
    originalCurrency: '原币币种',
    subjectOfTheOtherOarty: '对方主题',
    rmbAmount: '人民币金额',
    performancePeriod: '履行期限',
    signingDate: '签订日期',
    signer: '签章人',
    legalReview: '法律审核',
    audiStatus: '审批状态',
    noncharteringEdit: '非租船管理合同编辑',
    approvalOfMajorContractSigning: '合同签订审批',
    leaseAndAttachments: '租约及附件',
    textAndData: '文本及资料',
    performance: '履行情况',
    contractYear: '合同年份',
    numberFiles: '合同份数',
    urgency: '紧急程度',
    moneyFlow: '资金流向',
    bidWinningDate: '中标日期',
    expectedSigningDate: '预计签订日期',
    signingPlace: '签订地点',
    endDate2: '结束日期',
    effectiveConditions: '生效条件',
    targetAmount: '标的金额',
    amountOfMoney: '金额',
    currency: '币种',
    exchangeRateAgainstRMB: '兑人民币汇率',
    subjectMatterOfContract: '合同标的',
    contractPeriod: '合同期限',
    legalReviewOrNot: '是否经法律审核',
    mainTerms: '主要条款',
    sanctionsComplianceReview: '制裁合规审核',
    abstractContractRemarks: '备注：合同相对方、收发货人、货品、装卸港所在国家是否受到联合国、欧盟、英国、美国或其他国家地区的制裁。',
    shipTypeInformation: '船舶船型信息',
    associationType: '关联类型',
    shipType: '船型',
    ourContractInformation: '我方签约信息',
    guaranteeContract: '是否为合同提供担保',
    guaranteeUnit: '担保单位',
    weGuaranteeUnit: '我方担保单位',
    ourBackground: '我方背景',
    counterpartyInformation: '相对方信息',
    oppositeParty: '相对方',
    oppositeBackground: '相对方背景',
    classify: '分类',
    attachmentType: '附件类型',
    attachmentTitle: '附件标题',
    creationTime: '创建时间',
    createdBy: '创建人',
    modifiedBy: '修改人',
    modificationTime: '修改时间',
    confirmArchiving: '合同确认归档',
    legalSystem: '发送法务系统',
    testSending: '测试发送',
    contractFilingDate: '合同归档日期',
    contractArchiver: '合同归档人',
    totalContract: '合同总份数',
    contractFilingDepartment: '合同归档部门',
    numberContract: '合同归档份数',
    otherOriginalHoldingDepartments: '其他原件持有部门',
    numberOfSharesHeld: '持有份数',
    riskLevel: '风险等级',
    filingPeriod: '归档期限',
    placeOfArbitration: '仲裁地',
    pointOut: '提示',
    contractOppNo: '对方合同编号',
    secretFlag: '是否涉密',
    foreignFlag: '是否涉外合同',
    importantFlagLc: '是否轮船重大合同',
    importantHMFlag: '是否明华重大合同',
    lawFlag: '是否经法律审核',
    manageApproval: '商务代管管理合同审批单',
    noncharteringContractApprovalForm: '非租船管理合同审批单',
    noncharteringContractApprovalFormTitle: '非租船合同内部审批表（非重大）',
    viewAttachments: '查看附件',
    exportDoc: '导出Doc',
    viewForwardPallets: '查看远期货盘',
    contractSubject: '合同主体',
    opponents: '合同相对方',
    duration: '合同期限',
    opponentBackground: '对方背景',
    opponentBackgroundCheck01: '公司营业执照或商业登记证书',
    objectAmount: '合同标的/金额',
    lawJurisdiction: '适用法律/管辖地',
    placeDateSigning: '签字地点/日期',
    sanctionsComplianceReviewText: '经过审查，未发现合同相对方、收发货人、货品、装卸港所在国家受到联合国、欧盟、英国、美国或其他国家地区的制裁',
    fixedLoadDate: '定载日期',
    classificationFfGoods: '货物分类',
    carryingCargoYype: '承载货种',
    brokerInformation: '经纪人信息',
    expectedReturnVessel: '预计交还船',
    NatureLeaseTerm: '租期性质',
    routeIndex: ' 航线指数',
    indexRange: '指数范围',
    POOLManagement: 'POOL管理',
    backContract: '背靠背合同',
    demurrageCommission: '滞期费佣金',
    freightandVolume: '运费及货量',
    quantityDesignatedParty: '货量指定方',
    ILOW: 'ILOW条款(%)',
    loadingPeriodInformation: '受载期信息',
    loadingPort: '装货港',
    dischargingPort: '卸货港',
    loadingArea: '装货地区',
    unloadingArea: '卸货地区',
    dischargeTerms: '卸货条款',
    totalLoading: '装卸时间合计条款',
    loadingUnloadingRemarks: '装卸备注',
    BAFAdjustment: 'BAF燃油调整',
    benchmarkOilPrice: '基准油价',
    estimatedOilPrice: '预估实际油价',
    rate: '费率',
    minghuaSteamship: '上报对象',
    hongKongMinghua: '香港明华',
    steamboat: '轮船',
    indexType: '指数类型',
    describe: '描述',
    unitPrice: '单价',
    lumpSum: '包干',
    startingTimeLeaseTerm: '受载期开始时间',
    leaseEndTime: '受载期结束时间',
    quantitySingleCargo: '单载货物数量',
    designatedSingleCargoCapacity: '单载货量指定方',
    totalLoad: '总载数',
    totalCargoQuantity: '总载货物数量',
    designatedPartyTotalCargoCapacity: '总载货量指定方',
    freightTax2: '运费税',
    version: '合同版本',
    termInformation: '条款信息',
    receivingCommission: '租家回佣',
    time: '时间',
    historicalContracts: '历史版本',
    recordChangesFreightRates: '运价费率变更记录',
    otherExpenses: '其他费用',
    IMO: 'IMO编码',
    QuantityOfGoods: '货量',
    startPort: '起始港口',
    endPort: '结束港',
    elevenTab: '船东历史合同',
    twelveTba: '船东历史航次',
    voyageContract: '航次合同',
    coefficient: '系数',
    affiliatedVC: '所属VC父合同 ',
    freightRateBefore: '运价费率（调整前）',
    freightRateAfter: '运价费率（调整后）',
    adjustType: '调整类型',
    adjuster: '调整人',
    adjustTime: '调整时间',
    actualCargo: '实际货量'
  }
};